// test1974
(1974 && 0);
